var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { i18n, KEYS } from '../../../i18n';
import { copyLink, getQueryParams, sleep } from '../../../utils';
import { inject } from 'mobx-react';
import { BaseUserAppTYpe } from '../../../stores';
import { TextOverflow } from '../../TextOverflow';
import { theme } from '../../../theme';
import { toast } from 'react-toastify';
import { ShortUrl } from '../../../graphql/urlShorts';
import { MainButton } from '../../MainButton';
function MenuCopyCurrentLocation(_a) {
    var _this = this;
    var store = _a.store, client = _a.config.client;
    var _b = __read(React.useState(false), 2), loading = _b[0], setLoading = _b[1];
    var handleClickOpen = function () {
        var generateWarehouseLink = function () { return __awaiter(_this, void 0, void 0, function () {
            var version, url, params, paramsSorted, longLink, res, e_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        version = (_a = window.envirements.find(function (e) { return e.name === 'WAREHOUSE_SHARE_LINK_VERSION'; })) === null || _a === void 0 ? void 0 : _a.value;
                        url = location.href.split(location.origin)[1].substr(1).split('?')[0];
                        params = __assign({}, getQueryParams(location.search));
                        paramsSorted = Object.keys(params)
                            .sort()
                            .reduce(function (obj, key) {
                            obj[key] = params[key];
                            return obj;
                        }, {});
                        if (paramsSorted.order) {
                            delete paramsSorted.order;
                        }
                        longLink = [
                            (_b = store.accountStore.env.find(function (e) { return e.name === BaseUserAppTYpe.CARRIER; })) === null || _b === void 0 ? void 0 : _b.value,
                            'public',
                            url +
                                '?' +
                                new URLSearchParams(__assign({}, paramsSorted)).toString() +
                                (version && "&WAREHOUSE_SHARE_LINK_VERSION=" + version) || '',
                        ].join('/');
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 7]);
                        setLoading(true);
                        return [4 /*yield*/, client.mutate({
                                mutation: ShortUrl,
                                variables: {
                                    link: longLink,
                                },
                            })];
                    case 2:
                        res = _c.sent();
                        copyLink(res.data.shortUrl.result);
                        return [3 /*break*/, 7];
                    case 3:
                        e_1 = _c.sent();
                        toast.error(e_1.message);
                        console.log(e_1);
                        return [3 /*break*/, 7];
                    case 4: return [4 /*yield*/, sleep(1000)];
                    case 5:
                        _c.sent();
                        return [4 /*yield*/, setLoading(false)];
                    case 6:
                        _c.sent();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        generateWarehouseLink();
    };
    return (React.createElement(MainButton, { id: 'calendar-copy-link', onClick: handleClickOpen, loading: loading, color: 'primary', variant: "outlined", title: React.createElement(TextOverflow, { style: { color: theme.palette.secondary['900'], textDecoration: 'underline' } }, i18n.getResource(i18n.language, KEYS.APP, 'app_copy_shareable_link')), style: {
            border: 'none',
            textTransform: 'capitalize',
            paddingLeft: 0,
        } }));
}
export default inject('store')(MenuCopyCurrentLocation);
